import { Category, CategoryCourse } from "../../../types/category";
import apiClient from "../config";

export const getCategories = async (): Promise<Category[]> => {
  const { data } = await apiClient.get("/public/getAllCourseCategory");
  return data;
};

export const getCategoryCourses = async (
  categoryId: number,
): Promise<CategoryCourse[]> => {
  const { data } = await apiClient.get(
    `/public/getCoursesByCategory/${categoryId}`,
  );
  return data;
};

export const getCourseCategoryPics = async (
  courseCategoryId: number,
): Promise<string> => {
  const baseURL = apiClient.defaults.baseURL ?? "";
  return `${baseURL}/public/getCourseCategoryPics/${courseCategoryId}`;
};
